import { render, staticRenderFns } from "./ClassSelect.vue?vue&type=template&id=23e74af2"
import script from "./ClassSelect.vue?vue&type=script&lang=js"
export * from "./ClassSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports